import Image from 'next/image'
import { ClockIcon } from '@icons'
import { Tag } from '@platform/ui-kit'

import { ReactComponent as PinkGraph } from '../../../assets/icons/pink-graph-element.svg'
import { CTAButton } from '../../button'

import styles from './styles.module.scss'

type FeaturedArticleTypes = {
  picture: string
  tag: string
  title: string
  description: string
  minutesRead: number
  href: string
}

export const FeaturedArticle = ({
  picture,
  tag,
  title,
  description,
  minutesRead,
  href,
}: FeaturedArticleTypes) => {
  return (
    <div className={styles['card-wrapper']}>
      <div className={styles['picture-wrapper']}>
        <Image
          className={styles['picture']}
          src={picture}
          alt={`The ${title}'s article card`}
          priority
          fill
          sizes="100vw"
        />
      </div>
      <div className={styles['card-content']}>
        <Tag label={tag} className={styles['tag']} />
        <p className={styles['min-read']}>
          <ClockIcon className={styles['clock-icon']} />
          <span>{minutesRead} min read</span>
        </p>
        <p className={styles['title']} title={title}>
          {title}
        </p>
        <p className={styles['description']} title={description}>
          {description}
        </p>
        <CTAButton className={styles['cta-button']} size="medium" href={href} prefetch={false}>
          read more
        </CTAButton>
      </div>
      <PinkGraph className={styles['pink-graph']} />
    </div>
  )
}

export default FeaturedArticle
